import { ReactElement } from "react";

import BulkDropzone from "./bulk-dropzone";
import BulkFileChip from "./bulk-file-chip";

interface UploadStepProps {
  file: File | null;
  busy: boolean;
  validating: boolean;
  executed: boolean;
  onFile: (file: File) => void;
  onReset: () => void;
  onValidate: () => void;
}

/**
 * Step 2 — pick the workbook and run validate. Nothing about its contents is
 * checked here; validate mode on the server is what decides.
 */
const UploadStep: React.FC<UploadStepProps> = ({
  file,
  busy,
  validating,
  executed,
  onFile,
  onReset,
  onValidate,
}): ReactElement => (
  <div className="panel">
    <header>
      <h4>
        <span className="step">2</span>Upload and validate
      </h4>
      <p className="sub">Validation is read-only — nothing is created.</p>
    </header>

    <div className="body">
      {!file ? (
        <BulkDropzone onFile={onFile} />
      ) : (
        <BulkFileChip
          name={file.name}
          size={file.size}
          disabled={busy}
          onRemove={onReset}
        />
      )}
    </div>

    <div className="actions">
      {file && !executed && (
        <span className="hint">
          Validate as many times as you need — it never creates records.
        </span>
      )}
      <button
        type="button"
        className="btn ghost"
        disabled={!file || busy}
        onClick={onReset}
      >
        {executed ? "Start another upload" : "Cancel"}
      </button>
      {!executed && (
        <button
          type="button"
          className="btn primary"
          disabled={!file || busy}
          onClick={onValidate}
        >
          {validating ? "Validating…" : "Validate file"}
        </button>
      )}
    </div>
  </div>
);

export default UploadStep;
